/* eslint-disable padding-line-between-statements */
import { Loader, ModalBody, ModalFooter, ModalHeader, ModalNext, formatCurrency } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { Button } from '@jutro/legacy/components';
import PropTypes, { string } from 'prop-types';
import { useTranslator, IntlContext } from '@jutro/locale';
import _ from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import metadata from './DuplicatePaymentPopup.metadata.json5';
import styles from './DuplicatePaymentPopup.module.scss';
import dupMessages from './DuplicatePaymentPopup.messages';

function DuplicatePaymentPopup(props) {
    const {
        paymentDetails,
        isOpen,
        onResolve,
        currency,
        onAfterClose,
        payInvoices,
        config,
        makeOfferPayment
    } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, /* setIsLoading */] = useState(false);

    const translator = useTranslator();
    const intlContext = useContext(IntlContext);

    const handleContinue = useCallback((evt) => {
        // force override DuplicatePayment to true and continue with invoice payment...
        if (payInvoices) {
            payInvoices(evt, true);
        } else if (makeOfferPayment) {
            makeOfferPayment(config, true);
        }
        onResolve();
    }, [config, makeOfferPayment, onResolve, payInvoices]);

    const curAmt =((amount )=>{
        const curProps = {
            currencyDisplay: string,
            showFractions: true        
        }
        return formatCurrency(
            intlContext,
            curProps,
            { amount, currency }) 
    });

    const formatDate = ((inDate) =>{
        let retDate;
        const newDate = new Date(inDate);
        if (!_.isUndefined(inDate) && !_.isNull(inDate)){
            const formattedDay = newDate.getDate().toString().padStart(2, '0');
            const formattedMonth =  newDate.toLocaleDateString('en-us', { month: 'short' });
            const formattedYear = newDate.getFullYear();
            retDate = `${formattedMonth} ${formattedDay}, ${formattedYear}`;
        }
        return retDate;
    });

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        duplicatePaymentBodyId: {
            content: translator(dupMessages.duplicatePaymentDetectedBody, { amountx:  curAmt((paymentDetails.lastPaymentAmount)?.toFixed(2)), datex: formatDate(paymentDetails.lastPaymentDate) })
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            handleContinue
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext isOpen={isOpen} onAfterClose={onAfterClose}>
            <ModalHeader title={translator(dupMessages.duplicatePaymentDetectedTitle)} />
            <ModalBody>
                <Loader loaded={!isLoading}>
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={paymentDetails}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onResolve} type="outlined"> {translator(dupMessages.duplicatePaymentCancel)} </Button>
                <Button onClick={handleContinue}>{translator(dupMessages.duplicatePaymentContinue)}</Button>
            </ModalFooter>
        </ModalNext>
    )
}

DuplicatePaymentPopup.propTypes = {
    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func
};

DuplicatePaymentPopup.defaultProps = {
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop,
    onAfterClose: _.noop
};

export default DuplicatePaymentPopup;